import { render, staticRenderFns } from "./ReportTemplateEditor.vue?vue&type=template&id=20201ba2&"
import script from "./ReportTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./ReportTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports